<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Supplier Order Position</v-toolbar-title>
            <v-toolbar-title v-else>Edit Supplier Order Position - {{selectedItem.id}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>SUPPLIER ORDER POSITION</v-tab>
                <v-tab>WAREHOUSE RECEIVED</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">Supplier Order Position
                                        <v-spacer></v-spacer>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Product</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Product Reference"
                                                    v-model="selectedItem.product.reference"
                                                    disabled
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>

                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Manufacturer"
                                                    v-model="selectedItem.product.manufacturer.name"
                                                    disabled
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex xs12 md2 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Quantity"
                                                    v-model="selectedItem.quantity"
                                                    type="number"
                                                    min="1"
                                                    disabled
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    v-show="!getInitialLoading"
                                                    clearable
                                                    :items="getUnits"
                                                    label="Unit"
                                                    v-model="selectedItem.units_id"
                                                    item-value="id"
                                                    item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    id="unitPrice"
                                                    :suffix="getSupplierOfferCurrency"
                                                    label="Unit Price"
                                                    v-model.lazy="unitPrice"
                                                    v-money="money"
                                            ></v-text-field>

                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    :suffix="getSupplierOfferCurrency"
                                                    label="Total-Price"
                                                    :value="getTotalPrice"
                                                    disabled
                                            >
                                            </v-text-field>

                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="HS-Code"
                                                    v-model="selectedItem.product.hscode"
                                                    counter
                                                    maxlength="255"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    suffix="kg"
                                                    label="Net Weight"
                                                    v-model="selectedItem.product.weight"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker v-show="!getInitialLoading"
                                                            locale="de-DE"
                                                            landscape
                                                            mysql
                                                            :width="width = 500"
                                                            label="Est Delivery Date"
                                                            v-model="selectedItem.est_receiving_date"
                                                            format="DD.MM.YYYY"
                                                            dateOnly
                                            >
                                            </DatetimePicker>

                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-textarea
                                                    v-show="!getInitialLoading"
                                                    auto-grow
                                                    rows="4"
                                                    label="Product Description"
                                                    v-model="selectedItem.product.product_description.description"
                                                    counter
                                                    maxlength="500"
                                                    disabled
                                            ></v-textarea>
                                        </v-flex>

                                    </v-card-title>

                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn :loading="saveProcess" color="secondary"
                                                   @click.native="saveSupplierOrderPosition()">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>
                            </v-layout>
                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>

            <v-tab-item>
                <WarehouseReceived></WarehouseReceived>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
    import {
        Settings,
        SupplierOrder,
        SupplierOrderPosition
    } from '../../../store/namespace-helper'
    import DatetimePicker from '../../Shared/DatetimePicker.vue'
    import UploadDocumentPicker from '../../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'
    import FakeItem from '../../Shared/FakeItem.vue'
    import FakeTable from '../../Shared/FakeTable.vue'
    import ProcessHistory from '../../Shared/ProcessHistory.vue'
    import WarehouseReceived from '../SupplierOrderPositions/WarehouseReceived.vue'

    import {dateFunctionFilters} from '../../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../../mixins/initialLoadingMixin'
    import {comboAutoCompleteFiltersMixin} from '../../../mixins/comboAutoCompleteFiltersMixin'

    import {VMoney} from 'v-money'

    /*   import _ from 'lodash' */

    export default {
      components: {
        DatetimePicker,
        UploadDocumentPicker,
        DocumentTokenChip,
        FakeItem,
        FakeTable,
        ProcessHistory,
        WarehouseReceived
      },
      name: 'add-supplier-order-position',
      mixins: [dateFunctionFilters, initialLoadingMixin, comboAutoCompleteFiltersMixin],
      data () {
        return {
          activeTab: 0,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Status', value: 'customers_offers_status_id'},
                    {text: 'Valid Until', value: 'valid_until'}
          ],
          countries: this.$store.getters.countries,
          selectedOffers: [],
          selectedOfferIDs: [],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [5, 10, 25, 50, 100, 250],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          touchless: true,
          saveProcess: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: true /* doesn't work with directive */
          },
          discountTypes: ['percent'],
          unitPrice: null
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.initialLoadingTimeout(850)
              this.loadUnits()
              this.initUnitSalesPrice()
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.$store.dispatch(SupplierOrderPosition.actions.setSelectedSupplierOrderPosition, null)
          this.$store.dispatch(SupplierOrderPosition.actions.openCloseDialog)
          this.activeTab = 0
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
        saveSupplierOrderPosition () {
          let supplierOrderPosition = {
            id: this.selectedItem.id,
            quantity: this.selectedItem.quantity,
            unit_purchase_price: this.unit_purchase_price,
            units_id: this.selectedItem.units_id,
            est_receiving_date: this.selectedItem.est_receiving_date
          }

          this.$store.dispatch(SupplierOrderPosition.actions.saveSupplierOrderPosition, supplierOrderPosition)
        },
        initUnitSalesPrice () {
          var element = document.getElementById('unitPrice')
          var event = new Event('input')
          if (typeof element !== 'undefined' && element !== null) {
            element.value = ''
            element.dispatchEvent(event)
            element.value = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(this.selectedItem.unit_purchase_price)
            element.dispatchEvent(event)
          }
        }
      },
      computed: {
        selectedItem () {
          return this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition]
        },
        selectedSupplierOrder () {
          return this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder]
        },
        getSupplierOfferCurrency () {
          if (this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition] &&
                    this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition].suppliers_offers_position &&
                    this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition].suppliers_offers_position.suppliers_offer &&
                    this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition].suppliers_offers_position.suppliers_offer.currency) {
            return this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition].suppliers_offers_position.suppliers_offer.currency.name
          } else {
            return ''
          }
        },
        getTotalPrice () {
          return new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2

          }).format(this.selectedItem.unit_purchase_price * this.selectedItem.quantity)
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[SupplierOrderPosition.getters.getSelectedSupplierOrderPosition].id === 0
        }
      },
      watch: {
        unitPrice: {
          handler (val) {
            if (val !== null) {
              console.log('confirmUnitPrice: ' + val)
              var formatRemoved = val.replace(/\./g, '')
              formatRemoved = formatRemoved.replace(/,/g, '.')
              this.selectedItem.unit_purchase_price = formatRemoved
            }
          }
        }
      },
      directives: {money: VMoney}
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .process-history {
        text-align: right;
        width: 100%;
        font-size: 0.95rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/SupplierOrderPositions/AddSupplierOrderPosition.vue